import { Validator } from '@vueform/vueform';

import { i18n } from '../i18n/i18n';

export const MAX_CHARACTER_COUNT = 512;

export const characterLimitRule = class extends Validator {
  value = '';
  get characterLimit(): number {
    return (this.attributes[0] as number) || MAX_CHARACTER_COUNT;
  }
  check(value: string | null) {
    if (value === null) {
      return true;
    }

    if (value.length > this.characterLimit) {
      // Only set the value if it produces an error
      this.value = value;
      return false;
    }
    return true;
  }
  get msg() {
    return i18n.global.t(
      'message.global.forms.character_limit',
      {
        charsTooMany: this.value.length - this.characterLimit,
        max: this.characterLimit,
      },
      this.value.length - this.characterLimit,
    );
  }
};
